import { useRef, useState, useEffect } from "react";

interface LazyVideoProps {
  src: string;
  className?: string;
  style?: React.CSSProperties;
  /** Distance before viewport to start loading */
  rootMargin?: string;
}

const LazyVideo = ({ src, className, style, rootMargin = "200px" }: LazyVideoProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className={className} style={style}>
      {isVisible ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          className="w-full h-full object-cover"
          src={src}
        />
      ) : (
        <div className="w-full h-full bg-muted" />
      )}
    </div>
  );
};

export default LazyVideo;
